module.exports = __webpack_public_path__ + "static/img/cloud_saas_acceleration_img_1.4c4e8db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img_svg/cloud_saas_acceleration_img_1.png
// module id = ic4e
// module chunks = 0